import Vue from 'vue'
import router from '../../../router'
import moment from 'moment'

export const promoUsage = {
    state: {
        status: 'idle',
        promoUsageExportStatus: 'idle',
        promoUsage: null,
        pagination: {
            page: 1,
            totalPages: 0,
            perPage: 10,
            totalRecords: null
        },
        sortOptions: [
            {
                query: 'promoId',
                label: 'ID promocji'
            },
            {
                query: 'promoName',
                label: 'Promocja'
            },
            {
                query: 'amount',
                label: 'Liczba użyć'
            },
            {
                query: 'refAmount',
                label: 'Zwrot Kosztów'
            }
        ],
        sort: {
            by: 'promoId',
            direction: 'desc'
        },
        filters: {
            dates: {
                type: 'dates',
                value: '',
                text: 'Data',
                additionalText: 'Data',
                lockFutureDays: [moment().format('YYYY-MM-DD')],
                lockRangeDaysNumber: 31
            },
            shopIds: {
                type: 'ui-virtual-list',
                value: null,
                multi: true,
                searcher: false,
                label: 'Wybierz sklep',
                moduleName: 'merchants',
                fetchAction: 'merchantsFetch',
                getter: 'getDevicesShopsForSelect',
                resetFilter: 'radIds',
                disabledLinkGenerator: true
            },
            radIds: {
                type: 'ui-virtual-list',
                value: [],
                multi: true,
                searcher: false,
                label: 'Wybierz kasę',
                getter: 'getPromoUsageDevices',
                disabledLinkGenerator: true
            },
            promotionId: {
                type: 'ui-virtual-list',
                value: null,
                moduleName: 'promotions',
                label: 'Promocja',
                getter: 'getPromotionsForFilters'
            }
        }
    },
    mutations: {
        SET_PROMOUSAGE_STATUS(state, payload) {
            state.status = payload
        },
        SET_PROMOUSAGE(state, payload) {
            state.promoUsage = payload
        },
        SET_PROMOUSAGE_TOTALPAGES(state, payload) {
            state.pagination.totalPages = payload
        },
        SET_PROMOUSAGE_TOTALRECORDS(state, payload) {
            state.pagination.totalRecords = payload
        },
        SET_PROMOUSAGE_CURRENT(state, payload) {
            state.pagination.page = payload
        },
        SET_PROMOUSAGE_PERPAGE(state, payload) {
            state.pagination.perPage = payload
        },
        SET_PROMOUSAGE_FILTER(state, payload) {
            Vue.set(
                state.filters[payload.filter],
                payload.key || 'value',
                payload.value
            )
        },
        RESET_PROMOUSAGE_FILTERS(state, payload) {
            Vue.set(state, 'filters', payload)
        },
        SET_PROMOUSAGE_SORT(state, payload) {
            state.sort = payload
        },
        SET_PROMOUSAGE_EXPORT_STATUS(state, payload) {
            state.promoUsageExportStatus = payload
        }
    },
    actions: {
        fetchPromotionUsageReport({ commit, state, getters }) {
            const params = getters.getPromotionUsageQueryParams
            params.paging = {
                ...params.paging,
                numberOfRows: null
            }
            if (!params.startDate || !params.endDate) {
                params.startDate = Vue.moment()
                    .subtract(
                        state.filters.dates.lockRangeDaysNumber - 1,
                        'days'
                    )
                    .format('YYYY-MM-DD')
                params.endDate = Vue.moment().format('YYYY-MM-DD')
            }
            commit('SET_PROMOUSAGE_EXPORT_STATUS', 'loading')
            return this.$api
                .post('usageReportXlsx', params, {
                    responseType: 'arraybuffer'
                })
                .then(response => {
                    const today = Vue.moment().format('YYYY-MM-DD')

                    const fileLink = document.createElement('a')
                    const blob = new Blob([response.data], {
                        type: '"application/octet-stream"'
                    })
                    fileLink.href = window.URL.createObjectURL(blob)
                    fileLink.download = `Użycia promocji-${today}.xlsx`
                    fileLink.click()
                    commit('SET_PROMOUSAGE_EXPORT_STATUS', 'idle')
                })
                .catch(() => {
                    commit('SET_PROMOUSAGE_EXPORT_STATUS', 'idle')
                })
        },
        promoUsageFetch({ commit, state, getters }) {
            commit('SET_PROMOUSAGE_STATUS', 'loading')

            if (router.currentRoute.query.page) {
                commit(
                    'SET_PROMOUSAGE_CURRENT',
                    +router.currentRoute.query.page
                )
            }
            if (router.currentRoute.query.show) {
                commit(
                    'SET_PROMOUSAGE_PERPAGE',
                    +router.currentRoute.query.show
                )
            }

            const params = getters.getPromotionUsageQueryParams

            return this.$api
                .post('reports/promotionUsage', params)
                .then(res => {
                    commit(
                        'SET_PROMOUSAGE_TOTALRECORDS',
                        res.data.data.paging.count
                    )
                    commit(
                        'SET_PROMOUSAGE_TOTALPAGES',
                        Math.ceil(
                            res.data.data.paging.count /
                                state.pagination.perPage
                        )
                    )
                    commit('SET_PROMOUSAGE', res.data.data.usages)
                    commit('SET_PROMOUSAGE_STATUS', 'idle')
                })
                .catch(err => {
                    if (!this.$api.isCancel(err)) {
                        commit('SET_PROMOUSAGE_STATUS', 'idle')
                    }
                })
        },
        async promoUsageFiltersFetch({ dispatch }) {
            await dispatch('devicesFetch')
        },
        setPromoUsageSort({ commit }, payload) {
            commit('SET_PROMOUSAGE_SORT', payload)
        }
    },
    getters: {
        getPromotionUsageQueryParams: (state, allGetters) => {
            const shopIds = allGetters.getLocationIds

            const paging = {
                orderDirection: state.sort.direction.toUpperCase(),
                orderBy: state.sort.by,
                numberOfPage: state.pagination.page - 1,
                numberOfRows: state.pagination.perPage
            }

            let startDate = null
            let endDate = null

            if (state.filters.dates.value) {
                const dates = state.filters.dates.value.split(',')
                startDate = dates[0]
                endDate = dates[1]
            }

            return {
                paging,
                userId: allGetters.userId,
                shopIds: state.filters.shopIds.value
                    ? state.filters.shopIds.value
                    : shopIds,
                radIds:
                    state.filters.radIds.value &&
                    state.filters.radIds.value.length
                        ? state.filters.radIds.value
                        : null,
                promotionId: state.filters.promotionId.value,
                startDate,
                endDate
            }
        },
        getPromoUsage: state => {
            return state.promoUsage
        },
        getPromoUsageStatus: state => {
            return state.status
        },
        getPromoUsagePagination: state => {
            return state.pagination
        },
        getPromoUsageFilters: state => {
            return state.filters
        },
        getPromoUsageSortOptions: state => {
            return state.sortOptions
        },
        getPromoUsageSort: state => {
            return state.sort
        },
        getPromoUsageDevices: (state, getters) => {
            if (state.filters.shopIds.value) {
                const devices = []
                getters.getDevices
                    .filter(el =>
                        state.filters.shopIds.value.includes(el.location_id)
                    )
                    .forEach(v => {
                        v.devices.forEach(elem => {
                            devices.push({
                                label: `${elem.unique_number} - ${elem.mcuid}`,
                                value: elem.mcuid
                            })
                        })
                    })
                return devices
            }
        },
        getPromoUsageExportStatus: state => {
            return state.promoUsageExportStatus
        }
    }
}
